exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".spinner-container {\n  background: rgba(0, 0, 0, 0.3);\n  width: 100%;\n  height: 100%;\n  position: fixed;\n  top: 0px;\n  left: 0px;\n  z-index: 99999; }\n\n.spinner {\n  border: 5px solid #f3f3f3;\n  border-top: 5px solid #003a62;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  border-radius: 50%;\n  width: 50px;\n  height: 50px;\n  animation: spin 2s linear infinite; }\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/maxsheikhizadeh/Desktop/GEN/physician-portal/src/app/shared/components/spinner/spinner.component.scss
// module id = ../../../../../src/app/shared/components/spinner/spinner.component.scss
// module chunks = main